import { Routes, Route, Navigate } from 'react-router-dom';
import Welcome from '../pages/welcome';
import Home from '../pages/home';
import WelcomeConstants from '../pages/welcome/constants';
import HomeConstants from '../pages/home/constants';
import PrivateRoute from './privateRoute';
import LoginConstants from '../pages/login/constants';
import Login from '../pages/login';
import Carriers from '../pages/carriers';
import CarriersConstants from '../pages/carriers/constants';
import BranchesConstants from '../pages/branches/constants';
import Branches from '../pages/branches';
import { SULAHUB_ROLES } from '../common/constants/roles';
import BranchesDetailsConstants from '../pages/branch-details/constants';
import BranchDetails from '../pages/branch-details';
import UsersManagementForm from '../pages/users/users-management-form';
import UsersConstants from '../pages/users/constants';
import Loads from '../pages/business/loads';
import LoadsConstants from '../pages/business/loads/constants';
import FeatureFlag from '../common/components/feature-flag';
import Reports from '../pages/reports';
import ReportsConstants from '../pages/reports/constants';
import PreferencesConstants from '../pages/preferences/constants';
import Preferences from '../pages/preferences';
import { featureType } from '../common/components/feature-flag/interfaces/IFeatureFlagProps';
import Rounds from '../pages/smartcargas/rounds';
import RoundsConstants from '../pages/smartcargas/rounds/constants';
import WonOffers from '../pages/smartcargas/won-offers';
import WonOfferConstants from '../pages/smartcargas/won-offers/constants';
import Policy from '../pages/smartcargas/policy';
import PolicyConstants from '../pages/smartcargas/policy/constants';
import ConfirmationTerm from '../pages/smartcargas/confirmation-term';
import ConfirmationTermConstants from '../pages/smartcargas/confirmation-term/constants';
import Pool from '../pages/pool';
import PoolConstants from '../pages/pool/constants';

function getPrivateRouteElement(
    element: JSX.Element,
    accessRole?: string | string[],
) {
    return <PrivateRoute accessRole={accessRole}> {element} </PrivateRoute>;
}

const defaultRoute = <Navigate to={{ pathname: HomeConstants.PATH }} />;

const homeRoute = getPrivateRouteElement(<Home />);
const loadsRoute = getPrivateRouteElement(
    <FeatureFlag feature={featureType.SmartGerencial}>
        <Loads />
    </FeatureFlag>,
    [
        SULAHUB_ROLES.SYSTEM_PROFILES.SULA_USER,
        SULAHUB_ROLES.SYSTEM_PROFILES.MESA_PLUS_ADMIN,
        SULAHUB_ROLES.SYSTEM_PROFILES.OPERATION_USER,
    ],
);

const WonOffersRoute = getPrivateRouteElement(
    <FeatureFlag feature={featureType.SmartWeb}>
        <WonOffers />
    </FeatureFlag>,
    [
        SULAHUB_ROLES.SYSTEM_PROFILES.SULA_USER,
        SULAHUB_ROLES.SYSTEM_PROFILES.TP_ADMIN_USER,
        SULAHUB_ROLES.SYSTEM_PROFILES.TP_USER,
    ],
);

const carriersRoute = getPrivateRouteElement(<Carriers />, [
    SULAHUB_ROLES.SYSTEM_PROFILES.SULA_USER,
    SULAHUB_ROLES.SYSTEM_PROFILES.MESA_PLUS_ADMIN,
    SULAHUB_ROLES.SYSTEM_PROFILES.OPERATION_USER,
    SULAHUB_ROLES.SYSTEM_PROFILES.TP_ADMIN_USER,
]);
const branchRoute = getPrivateRouteElement(<Branches />, [
    SULAHUB_ROLES.SYSTEM_PROFILES.SULA_USER,
    SULAHUB_ROLES.SYSTEM_PROFILES.MESA_PLUS_ADMIN,
    SULAHUB_ROLES.SYSTEM_PROFILES.OPERATION_USER,
    SULAHUB_ROLES.SYSTEM_PROFILES.TP_ADMIN_USER,
]);

const branchDetailsRoute = getPrivateRouteElement(<BranchDetails />, [
    SULAHUB_ROLES.SYSTEM_PROFILES.SULA_USER,
    SULAHUB_ROLES.SYSTEM_PROFILES.MESA_PLUS_ADMIN,
    SULAHUB_ROLES.SYSTEM_PROFILES.OPERATION_USER,
    SULAHUB_ROLES.SYSTEM_PROFILES.TP_ADMIN_USER,
]);

const reportsRoute = getPrivateRouteElement(<Reports />, [
    SULAHUB_ROLES.SYSTEM_PROFILES.SULA_USER,
    SULAHUB_ROLES.SYSTEM_PROFILES.MESA_PLUS_ADMIN,
    SULAHUB_ROLES.SYSTEM_PROFILES.OPERATION_USER,
    SULAHUB_ROLES.SYSTEM_PROFILES.TP_ADMIN_USER,
    SULAHUB_ROLES.SYSTEM_PROFILES.TP_USER,
]);

const roundsRoute = getPrivateRouteElement(
    <FeatureFlag feature={featureType.SmartWeb}>
        <Rounds />
    </FeatureFlag>,
    [
        SULAHUB_ROLES.SYSTEM_PROFILES.TP_ADMIN_USER,
        SULAHUB_ROLES.SYSTEM_PROFILES.TP_USER,
    ],
);

export default function Routing() {
    return (
        <Routes>
            <Route path={WelcomeConstants.default} element={<Welcome />} />
            <Route path={LoginConstants.default} element={<Login />} />
            <Route path={HomeConstants.PATH} element={homeRoute} />
            <Route path={LoadsConstants.PATH} element={loadsRoute} />
            <Route path={CarriersConstants.PATH} element={carriersRoute} />
            <Route path={BranchesConstants.PATH} element={branchRoute} />
            <Route
                path={BranchesDetailsConstants.PATH}
                element={branchDetailsRoute}
            />
            <Route
                path={UsersConstants.PATH}
                element={<UsersManagementForm tab="1" />}
            />
            <Route
                path={UsersConstants.PATH_USER_REQUEST}
                element={<UsersManagementForm tab="2" />}
            />
            <Route path={ReportsConstants.PATH} element={reportsRoute} />
            <Route path={RoundsConstants.PATH} element={roundsRoute} />
            <Route path={PreferencesConstants.PATH} element={<Preferences />} />
            <Route path={WonOfferConstants.PATH} element={WonOffersRoute} />
            <Route path={PolicyConstants.default} element={<Policy />} />
            <Route
                path={ConfirmationTermConstants.default}
                element={<ConfirmationTerm />}
            />
            <Route path={PoolConstants.PATH} element={<Pool />} />
            <Route path="*" element={defaultRoute} />
        </Routes>
    );
}
